(() => {
  const STORAGE_KEY = 'salut:wishlist';
  const CHANGE_EVENT = 'salut:wishlist:change';

  const isHandle = (value) => typeof value === 'string' && value !== '' && /[^0-9]/.test(value);

  const read = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(stored) ? stored.filter(isHandle) : [];
    } catch {
      return [];
    }
  };

  const write = (handles) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch {
      /* storage unavailable */
    }
  };

  const syncButtons = (root = document) => {
    const handles = read();
    root.querySelectorAll('[data-salut-wishlist]').forEach((button) => {
      button.setAttribute('aria-pressed', handles.includes(button.dataset.salutWishlist) ? 'true' : 'false');
    });
  };

  const syncCounters = (root = document) => {
    const total = read().length;
    root.querySelectorAll('[data-salut-wishlist-count]').forEach((counter) => {
      counter.textContent = total > 99 ? '99+' : String(total);
      counter.hidden = total === 0;
    });
  };

  const sync = (root = document) => {
    syncButtons(root);
    syncCounters(root);
  };

  const publish = () => {
    sync();
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { handles: read() } }));
  };

  const toggle = (handle) => {
    if (!isHandle(handle)) return false;

    const handles = read();
    const index = handles.indexOf(handle);
    const added = index === -1;

    if (added) {
      handles.push(handle);
    } else {
      handles.splice(index, 1);
    }

    write(handles);
    publish();
    return added;
  };

  const remove = (handle) => {
    const handles = read();
    const index = handles.indexOf(handle);
    if (index === -1) return false;

    handles.splice(index, 1);
    write(handles);
    publish();
    return true;
  };

  window.SalutWishlist = {
    changeEvent: CHANGE_EVENT,
    get: read,
    has: (handle) => read().includes(handle),
    count: () => read().length,
    toggle,
    remove,
    sync,
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-salut-wishlist]');
    if (!button) return;

    toggle(button.dataset.salutWishlist);
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return;
    publish();
  });

  document.addEventListener('shopify:section:load', (event) => sync(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sync());
  } else {
    sync();
  }
})();
